import React from 'react';
import AddAddressModal, {
    Address,
} from '../prescriptionPad/rightPanel/finishScreen/AddAddressModal';
import ModalDialog from '../common/ModalDialog';
import setPatientAddress from '../../api/setPatientAddress';
import { notification } from 'antd';
import { Patient } from '../../store/types/patient';
import { getPincode } from '../prescriptionPad/rightPanel/finishScreen/OrderMedicineUtils';
import { getMySingleDoctorId } from '../../store/idbHandler';

const AddAddressGlobalSearch: React.FC<{
    patient: Patient | undefined;
    setShowAddAddress: (val: boolean) => void;
}> = (props) => {
    const { patient, setShowAddAddress } = props;

    const setAddressHandler = (address: Address) => {
        const { _id, line, address: add, city, state, placeID, latLng, pincode } = address;
        const docId = getMySingleDoctorId() || '';

        if (!add || !line || !city || !state || !pincode) {
            notification.error({
                message: 'Please fill all fields',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }

        setPatientAddress(docId, {
            _id,
            pid: patient?.id || '',
            address: {
                line1: line,
                line2: add,
                city,
                state,
                place_id: placeID,
                coordinates: latLng,
                pincode,
            },
        })
            .then((i) => {
                if (i.success) {
                    notification.success({
                        message: 'Address saved succesfully!',
                        duration: 5,
                        placement: 'topRight',
                    });
                } else {
                    notification.error({
                        message: i.error,
                        duration: 5,
                        placement: 'topRight',
                    });
                }
                setShowAddAddress(false);
            })
            .catch((err) => {
                notification.error({
                    message: err.error,
                    duration: 5,
                    placement: 'topRight',
                });
                setShowAddAddress(false);
            });
    };

    return (
        <ModalDialog>
            <AddAddressModal
                closeMe={() => setShowAddAddress(false)}
                setAddress={setAddressHandler}
                showForm={false}
                patientId={patient?.id || ''}
                pincode={getPincode(patient)}
                zIndex={9999}
            />
        </ModalDialog>
    );
};

export default AddAddressGlobalSearch;
